import { http } from "../../../components/services/httpService";

export async function fetchRefContractTypes() {
    const token = localStorage.getItem( "token" );
    const res = await http(
        'ref/contract/types',
        {
            headers: { Authorization: `Bearer ${token}` },
        }
    );
    if ( !res.ok ) {
        throw new Error( `Failed to fetch reference: contract types: ${res.status}` );
    }
    return await res.json();
}
